/**
 * The app registry (GET /api/apps/ on nexus-core), from the shared
 * RegistryProvider — fetched once for the whole shell.
 *
 * Returns only the apps the current user's groups permit (filtering
 * happens server-side in core.portal_apps + core.portal_app_groups).
 * Each row carries the iframe_url the IframeView should load.
 */

import { useRegistry } from "./RegistryContext";

export function useApps() {
  const { apps, loading, error } = useRegistry();
  return { data: apps, loading, error };
}
